import { Stack } from '@mantine/core';
import type { FC } from 'react';
import type { Control } from 'react-hook-form';

import { VenueSelect } from '../../../../components/form/VenueSelect.tsx';
import { Textarea } from '../../../../components/reactHookFormMantine/Textarea.tsx';
import { useI18n } from '../../../../hooks/useI18n.ts';
import type { IncompleteEventFormComplete } from '../../IncompleteEventForm/schema.ts';

export const LiveEventSettings: FC<{
  control: Control<IncompleteEventFormComplete>;
}> = ({ control }) => {
  const { t } = useI18n();

  return (
    <Stack gap="xs">
      <VenueSelect control={control} label={t('where-and-when_label--venue') ?? 'Choose venue'} name="venue" />
      <Textarea
        autosize
        control={control}
        description={
          t('where-and-when_description--custom-venue') ??
          'If the venue is not listed in the dropdown above, please write the name of the venue here'
        }
        label={t('where-and-when_label--custom-venue') ?? 'Custom venue'}
        minRows={2}
        name="customVenue"
        placeholder={
          t('where-and-when_placeholder--custom-venue') ?? 'Enter venue name if not available in the dropdown'
        }
      />
    </Stack>
  );
};
